import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function CiclosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CICLOS = process.env.REACT_APP_URL_CICLOS;
  const [name, setName] = useState("");
  const [fecha_inicio, setFechaInicio] = useState("");
  const [fecha_fin, setFechaFin] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setName("");
    setFechaInicio("");
    setFechaFin("");
    setValidaBoton(true);
  };

  const saveCiclos = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_CICLOS,
        {
          name,
          fecha_inicio,
          fecha_fin,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Ciclo",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea un Ciclo nuevo</h3>
        <Form onSubmit={saveCiclos}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Ciclo
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Nombre del Ciclo"
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <br />
            <Label>Fecha Inicio</Label>
            <Input
              type="date"
              value={fecha_inicio}
              required
              onChange={(e) => {
                setFechaInicio(e.target.value);
              }}
            />
            <br />
            <Label>Fecha Fin</Label>
            <Input
              type="date"
              value={fecha_fin}
              required
              onChange={(e) => {
                setFechaFin(e.target.value);
              }}
            />
          </FormGroup>
          <br />
          <Row>
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                // text="SweetAlert in React"
                onConfirm={() => {
                  setText(false);
                  window.location.href = "/MenuEscuelas";
                }}
              />
            </div>
            <Button
              href="/MenuCatalogos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default CiclosCreate;
